var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "full-height" },
    [
      _c("pick-price-drive", { attrs: { "selected-index": 0 } }),
      _vm._v(" "),
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-breadcrumb", {
                    staticClass: "mb-sm-0",
                    attrs: { items: _vm.breadcrumbs }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("h1", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.title) +
                              "\n                        "
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "main-content" },
                    [
                      _c(
                        "b-col",
                        {
                          ref: "vehicleDetails",
                          staticClass: "vehicle-details",
                          attrs: { sm: "5", "order-sm": "1" }
                        },
                        [
                          _vm.isLoading && _vm.firstLoad
                            ? _c(
                                "div",
                                { staticClass: "w-100" },
                                [_c("vehicle-card-loader")],
                                1
                              )
                            : _c(
                                "affix",
                                {
                                  style: {
                                    width: _vm.enableAffix ? _vm.affixWidth : ""
                                  },
                                  attrs: {
                                    "relative-element-selector":
                                      ".left-content",
                                    enabled: _vm.enableAffix,
                                    offset: { top: 60, bottom: 0 }
                                  }
                                },
                                [
                                  _vm.largeVehicleCard && _vm.vehicle
                                    ? _c("vehicle-card", {
                                        attrs: {
                                          vehicle: _vm.vehicle,
                                          "exterior-color-code":
                                            _vm.exteriorColorCode,
                                          "options-cost": _vm.totalOptionsCost
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.largeVehicleCard && _vm.vehicle
                                    ? _c("small-vehicle-card", {
                                        attrs: {
                                          vehicle: _vm.vehicle,
                                          "exterior-color-code":
                                            _vm.exteriorColorCode,
                                          "options-cost": _vm.totalOptionsCost
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.vehicle
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-sm-block d-none price-details"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "label" },
                                                [
                                                  _vm._v(
                                                    "\n                                         \n                                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "value" },
                                                [_c("small", [_vm._v("MSRP")])]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "label" },
                                                [
                                                  _vm._v(
                                                    "\n                                        Base Price\n                                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "value" },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm._f("numeral")(
                                                          _vm.baseMsrp,
                                                          "$0,0"
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "label" },
                                                [
                                                  _vm._v(
                                                    "\n                                        Options\n                                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "value" },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.totalOptionsCost > 0
                                                          ? "+"
                                                          : ""
                                                      ) +
                                                      _vm._s(
                                                        _vm._f("numeral")(
                                                          _vm.totalOptionsCost,
                                                          "$0,0"
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("hr"),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between total"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "label" },
                                                [
                                                  _c("strong", [
                                                    _vm._v("Total")
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "value text-right"
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("numeral")(
                                                          _vm.totalCost,
                                                          "$0,0"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _c("br"),
                                                  _c("small", [
                                                    _vm._v("Plus taxes & fees.")
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-center my-4 d-sm-block d-none"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "w-100" },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "mb-2 mx-auto px-4",
                                              attrs: {
                                                variant: "orange",
                                                disabled: _vm.disabled
                                              },
                                              on: { click: _vm.next }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(_vm.nextLabel) +
                                                  "\n                                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          !_vm.lastStep
                                            ? _c(
                                                "b-link",
                                                {
                                                  on: {
                                                    click: _vm.gotoVehiclePage
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        I'm done. Skip to Summary\n                                    "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "left-content py-3 py-md-0",
                          attrs: { sm: "7" }
                        },
                        [_vm._t("default")],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.lastStep
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "bottom-actions-lg d-flex flex-column d-sm-none"
                        },
                        [
                          _c(
                            "b-row",
                            {
                              staticClass: "d-flex p-2 justify-content-center"
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mx-auto px-4",
                                  attrs: {
                                    variant: "orange",
                                    disabled: _vm.disabled
                                  },
                                  on: { click: _vm.next }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.nextLabel) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              _c(
                                "b-link",
                                {
                                  staticClass: "mx-auto px-4",
                                  on: { click: _vm.gotoVehiclePage }
                                },
                                [
                                  _vm._v(
                                    "\n                            I'm done. Skip to Summary\n                        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "bottom-actions-sm d-flex flex-column justify-content-center d-sm-none"
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mx-auto px-4",
                              attrs: {
                                variant: "orange",
                                disabled: _vm.disabled
                              },
                              on: { click: _vm.next }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.nextLabel) +
                                  "\n                    "
                              )
                            ]
                          )
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("user-confirmation-modal"),
          _vm._v(" "),
          _c("user-choice-needed-modal")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }